import { Resources } from 'constants/resources';

import { useNavigateToRoot } from 'hooks/useNavigateToRoot';
import { HttpError, SimpleForm, useCreate, useNotify } from 'react-admin';
import { FieldValues, SubmitHandler } from 'react-hook-form';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';
import { getSubmissionErrors } from 'utils/getSubmissionErrors';

import { ApiClientCreateFormValues, ApiClientsCreateForm } from './ApiClientsCreateForm';

type ApiClientCreatePayload = Omit<ApiClientCreateFormValues, 'merchant'> & {
  merchant: string | null;
};

const transform = (data: ApiClientCreateFormValues): ApiClientCreatePayload => {
  return {
    ...data,
    merchant: data.merchant || null,
  };
};

export const ApiClientsCreate = () => {
  const notify = useNotify();
  const { toRoot } = useNavigateToRoot();
  const [create] = useCreate<ApiClientCreatePayload>();

  async function onSubmit(values: ApiClientCreateFormValues) {
    try {
      const data = await create(
        Resources.ApiClients,
        { data: transform(values) },
        { returnPromise: true },
      );
      notify(`Клиент API ${data?.name} создан`, { type: 'success' });
      toRoot();
    } catch (error) {
      notify(`Ошибка: ${(error as Error).message || 'ошибка сервера'}`, {
        type: 'error',
        autoHideDuration: 3000,
      });
      return getSubmissionErrors(error as HttpError);
    }
  }

  return (
    <CreatePage listName="Клиенты API" title="Создание Клиента API">
      <SimpleForm
        onSubmit={onSubmit as SubmitHandler<FieldValues>}
        sanitizeEmptyValues
        sx={{ '&.MuiCardContent-root': { padding: 0 } }}
        toolbar={false}
      >
        <ApiClientsCreateForm />
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
            <SaveButton key="save-button" />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
    </CreatePage>
  );
};
